import TheLayout from "./TheLayout";

export { TheLayout };
